import Admin from "../Admin";
import React from "react";
import CardAdminDiagnosisCodeList from "../../../Component/Card/Admin/DiagnosisCode/CardAdminDiagnosisCodeList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class DiagnosisCodeList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminDiagnosisCodeList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/diagnosisCode",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Diagnosis Codes" buttons={buttons} />;
  }
}
